import React, { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { CampaignRequest } from "../../../../apis/campaign/CampaignRequest";
import { cancel } from "../../../../assets/icons";
import SmallButton from "../../../../components/button/SmallButton";
import { ActionType } from "../../../../store/campaign/action";
import CampaignContext from "../../../../store/campaign/CampaignContext";

const DeleteCampaignModal = () => {
  const { CampaignDispatch, CampaignState } = useContext(CampaignContext);
  const { showDeleteCampaign } = CampaignState;
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const goBack = () => {
    CampaignDispatch({
      type: ActionType.ShowDeleteCampaign,
      payload: {
        id: 0,
        status: false,
      },
    });
  };

  const DeleteCampaignModal = async () => {
    await mutation.mutate();
  };

  const queryClient = useQueryClient();
  const mutation = useMutation(
    () => CampaignRequest.deleteCampaign(showDeleteCampaign.id),
    {
      onMutate: () => {
        setSubmitting(true);
      },
      onSettled: async (data: any, error: any) => {
        if (error) {
          console.log(error);
        } else {
          await queryClient.invalidateQueries("getCampaign");
          goBack();
        }
      },
    }
  );

  return (
    <div className="fixed z-50 h-screen inset-0 flex justify-center md:items-center items-start bg-black bg-opacity-70">
      <div className="bg-white w-1/4 h-auto rounded-xl my-auto mx-auto font-med">
        <div className="flex w-full justify-end items-center px-8 pb-5 pt-8">
          <img
            src={cancel}
            alt="cancel"
            className="cursor-pointer w-5"
            onClick={goBack}
          />
        </div>
        <div className="px-10 pb-3">
          <div className="flex flex-col items-center">
            <h1 className="text-xl">Delete Campaign</h1>
            <h1 className="text-base text-center w-60 text-textPrimary mt-4 font-rom">
              Are you sure you want to delete the Campaign ?
            </h1>
          </div>

          <div className="flex justify-center my-8 outline-none">
            <SmallButton
              loadColor={"white"}
              type={"button"}
              handleClick={goBack}
              color={"bg-white"}
              border={"border-2"}
              borderColor={"border-breadscrumbColor"}
              hoverColor={"opacity-70"}
              text={"Cancel"}
              textColor={"text-textPrimary"}
              height={10}
            />
            <div className="mx-1.5"></div>
            <SmallButton
              isSubmitting={isSubmitting}
              loadColor={"white"}
              type={"button"}
              height={10}
              handleClick={DeleteCampaignModal}
              color={"bg-primary"}
              hoverColor={"bg-red-300"}
              text={"Delete"}
              textColor={"text-white"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteCampaignModal;
